import React from 'react';
import styles from '../UserDropdown.module.scss';
import Div from '../../Element/Div/Div';
import Flex from '../../Flex/Flex';
import Icon from '../../Icon/Icon';
import Gutter from '../../Gutter/Gutter';
import BodyText from '../../Typography/BodyText/BodyText';
import { CommonProps } from '../../Element/Element';
import { SupportedIconName } from '../../../shared/icons';

export type UserDropDownItemProps = {
  /** String for icon name */
  iconName: SupportedIconName;
  /** Function when dropdown item is clicked */
  onClick: () => void;
  /** Label for dropdown item */
  children: any;
} & CommonProps<'div'>;

const UserDropdownItem: React.FunctionComponent<UserDropDownItemProps> = ({
  iconName,
  children,
  onClick,
  ...props
}) => {
  return (
    <Div
      padding={{ size: 'md' }}
      clickableAppearance
      backgroundHoverColor="gray100"
      className={styles.userDropdown__borderBottom}
      onClick={onClick}
      {...props}
    >
      <Flex centeredVertically>
        <Icon name={iconName} size="md" color="black" />

        <Gutter />

        <BodyText tagName="span" block fontWeight="medium" color="black">
          {children}
        </BodyText>
      </Flex>

      <Gutter size="xs" />
    </Div>
  );
};

export default UserDropdownItem;
